import { faChartLine } from "@fortawesome/free-solid-svg-icons";
import { useServiceStore } from "../store/service";
import { commonMenuItems } from "./common";
import defaultProfile, { asyncRoute } from "./default";
import type { GameProfile, Menu, ProfileCtx } from "./types";
import { MenuItem } from "./types";
import { i18n } from "../i18n";

const { t } = i18n.global;

const createMenu = (ctx: ProfileCtx): Menu => {
  const settingsMenuSection = {
    name: "settings",
    items: [
      new MenuItem(
        "",
        faChartLine,
        asyncRoute(() => import("../components/views/status/farmingSimulator/FarmingSimulatorStatus.vue")),
      ),
      commonMenuItems.settings,
      commonMenuItems.fileManager,
    ],
  };

  return [settingsMenuSection, ...defaultProfile(ctx).menu.slice(1)];
};

const join = () => {
  window.open(t("ngp/settings/section/farming_simulator_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(ctx),
  statusPageConfig: {
    ...defaultProfile(ctx).statusPageConfig,
    showRconPort: true,
  },
  join: {
    buttonTextKey: "ngp/settings/section/farming_simulator_wiki",
    joinFn: join,
  },
  accessDataFn() {
    const service = useServiceStore();
    return service.ctx.sys?.gameServer?.serverIp;
  },
});
